"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autosave = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Autosave = function (_a) {
    var id = _a.id;
    var clipPathId = id ? "Autosave__clip0__".concat(id) : 'Autosave__clip0';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("g", { clipPath: "url(#".concat(clipPathId, ")") },
            react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.345 3.023c3.344-.284 6.35 2.06 6.929 5.404 3.282.124 5.844 2.916 5.722 6.236-.123 3.32-2.883 5.911-6.165 5.787H5.403C2.42 20.45 0 18.003 0 14.985S2.42 9.52 5.403 9.52C5.423 6.126 8 3.307 11.345 3.023zm-.225 12.87l4.593-4.635v.022a.562.562 0 00.01-.776l-.572-.58a.547.547 0 00-.768 0l-3.63 3.673-1.34-1.355a.547.547 0 00-.768 0l-.583.59a.551.551 0 000 .765l2.301 2.296a.516.516 0 00.757 0z", clipRule: "evenodd" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: clipPathId },
                react_1.default.createElement("path", { fill: "currentColor", d: "M0 0H24V24H0z" })))));
};
exports.Autosave = Autosave;
//# sourceMappingURL=autosave.js.map